var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.27 18.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.56px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.6,6.59h3.89M.78,15.68v-3.59M.78,12.09h3.7M.78,12.09l3.3,3.3c3.34,3.34,8.76,3.34,12.11,0,1.06-1.06,1.83-2.39,2.22-3.84M1.86,7.13C3.09,2.56,7.78-.15,12.35,1.07c1.45.39,2.78,1.15,3.84,2.22l3.3,3.3M19.49,2.69v3.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.31,6.49c-.59.59-1.14,1.21-1.64,1.85-.3.38-.26.93.09,1.28l4.6,4.6c.39.39,1.02.39,1.4,0l3.28-3.28c.39-.39.39-1.02,0-1.4l-4.6-4.6c-.35-.35-.89-.39-1.28-.09-.65.51-1.26,1.06-1.85,1.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.9aedac84c606ab6231861702cdf5ba18.svg";
export { ForwardRef as ReactComponent };